import * as Yup from 'yup'

export const LASER_KEYWORD = 'laser'

export const emrCodeSchema = Yup.object({
  active: Yup.number().required(),
  code: Yup.string().required(),
  code_text: Yup.string().nullable().optional(),
  code_text_short: Yup.string().nullable().optional(),
  code_type: Yup.string().required(),
  id: Yup.number().required(),
})

export const validationSchema = Yup.object({
  activeTab: Yup.string().oneOf(['cpt', 'icd']).required(),
  isLaser: Yup.boolean().required(),
  cpt4_code: Yup.mixed().when('activeTab', {
    is: 'icd',
    then: () => emrCodeSchema.nullable().optional(),
    otherwise: () => emrCodeSchema.required('Procedure is required').nullable(),
  }),
  icd10_codes: Yup.mixed().when('activeTab', {
    is: 'icd',
    then: () =>
      Yup.array().of(emrCodeSchema).min(1, 'At least one ICD code is required').required(),
    otherwise: () => Yup.array().of(emrCodeSchema),
  }),
  procedure_units: Yup.string().nullable().optional(),
  units: Yup.number().typeError('Units must be a number').positive().required('Units is required'),
  price: Yup.number()
    .typeError('Price must be a number')
    .positive()
    .min(0, 'Price must be greater than or equal to 0')
    .required('Price is required'),
  area: Yup.string().nullable().optional(),
  energy: Yup.string().nullable().optional(),
  pulse_per_section: Yup.string().nullable().optional(),
  total_energy: Yup.string().nullable().optional(),
  discount_type_id: Yup.string().nullable().optional(),
})

export type FormValues = Yup.InferType<typeof validationSchema>
